import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Projects from './pages/Projects';
import ProjectDetails from './pages/ProjectDetails';
import Blog from './pages/Blog';
import Header from './components/Header'; // Import the Header component
import Footer from './components/Footer'; // Import the Footer component


function App() {
  return (
    <div>
      <Header /> {/* Include the Header component */}
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/projects' element={<Projects />} />
        <Route path='/projects/:id' element={<ProjectDetails />} />
        <Route path='/blog' element={<Blog />} />
      </Routes>

      <Footer /> {/* Include the Footer component */}
    </div>
  );
}

export default App;
